<template>
       <!-- 业务办理 -->
<section>
     <br>
     <br>
<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
    <div id="w" style="display: flex; width:100%; height:100%;position:relative;">
      <transition name="el-zoom-in-center">
        <div v-show="show2" id="s" style="margin:0 auto;" v-on:click="machineInit('TrainingCard')"  >
           <el-row>
           <el-col :span="22">
          <el-card shadow="hover" :body-style="{ padding: '8px'  }">
          <img v-bind:src="TrainingCard" class="image">
          <div style="margin: 0 auto;display:block;text-align:center; ">
          <label style="width:100%; height:100%;">培训卡业务</label>
        
          </div>
           </el-card>
          </el-col>
          </el-row>
            
        </div>

        
      </transition>  
      <transition name="el-zoom-in-center">
        <div v-show="show2"   style="margin:0 auto;" v-on:click="machineInit('FrequencyCard')"  >
           <el-row >
           <el-col :span="22">
          <el-card shadow="hover" :body-style="{ padding: '8px' }" v-on:mouseover="changeActive($event)" v-on:mouseout="removeActive($event)">
          <img v-bind:src="FrequencyCard" class="image">
          <div style="margin: 0 auto;display:block;text-align:center; ">
          <label style="width:100%; height:100%;" >次卡业务</label>     	  
          </div>
           </el-card>
          </el-col>
          </el-row>
            
        </div>

        
      </transition>
      

 <transition name="el-zoom-in-bottom">
        <div v-show="show2" style="margin:0 auto;" v-on:click="machineInit('MonthCard')"  >
           <el-row >
           <el-col :span="22">
          <el-card shadow="hover" :body-style="{ padding: '8px'  }">
          <img v-bind:src="MonthCard" class="image">
          <div style="margin: 0 auto;display:block;text-align:center; ">
          <label style="width:100%; height:100%;">月卡业务</label>       
          </div>
           </el-card>
          </el-col>
          </el-row>           
        </div>       
      </transition>
        <transition name="el-zoom-in-top">
        <div v-show="show2" style="margin:0 auto;" v-on:click="machineInit('YearCard')"  >
           <el-row>
           <el-col :span="22">
          <el-card shadow="hover" :body-style="{ padding: '8px'  }">
          <img v-bind:src="YearCard" class="image">
          <div style="margin: 0 auto;display:block;text-align:center; ">
          <label style="width:100%; height:100%;">年卡业务</label>   
          </div>
           </el-card>
          </el-col>
          </el-row>           
        </div>       
      </transition>
       <transition name="el-zoom-in-bottom">
        <div v-show="show2" style="margin:0 auto;" v-on:click="machineInit('RechargeableCard')"  >
           <el-row>
           <el-col :span="22">
          <el-card shadow="hover" :body-style="{ padding: '8px'  }">
          <img v-bind:src="RechargeableCard" class="image">
          <div style="margin: 0 auto;display:block;text-align:center; ">
          <label style="width:100%; height:100%;">充值卡业务</label>
        
          </div>
           </el-card>
          </el-col>
          </el-row>
            
        </div>

        
      </transition>
       <transition name="el-zoom-in-bottom">
        <div v-show="show2" style="margin:0 auto;" v-on:click="machineInit('Rechargeable')"  >
           <el-row>
           <el-col :span="22">
          <el-card shadow="hover" :body-style="{ padding: '8px'  }">
          <img v-bind:src="RechargeableCardXC" class="image">
          <div style="margin: 0 auto;display:block;text-align:center; ">
          <label style="width:100%; height:100%;">业主卡业务</label>
        
          </div>
           </el-card>
          </el-col>
          </el-row>
            
        </div>

        
      </transition>


   
    </div>
<br>
</el-col>


        <el-dialog  title="请检查读卡器是否连接" custom-class style="width:100%;margin: 0 auto;padding-top: 0px;padding-right: 0.25em;padding-bottom: 2ex;padding-left: 0px;"  v-model="Machine" :close-on-click-modal="false" >
     <el-row >
      <el-col :span="25" >
      <el-card :body-style="{ padding: '0px'  }">
      <!-- <img v-bind:src="IdCard" class="image"> -->
      <div >
       
          	<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form :inline="true"  style="float: right;" @submit.native.prevent>
        <!-- <span>请检查读卡器</span> -->
				<el-form-item >
					<input class="input" ref="siteInput"  v-model="inputIdCard"  clearable @keyup.enter="BusinessHandle" :autofocus="focusvalue" placeholder="卡号" />
				</el-form-item>
				<el-form-item>
					<el-button  type="primary" v-on:click="BusinessHandle" icon="el-icon-search">办理业务</el-button>
				</el-form-item>
				
			</el-form>
		</el-col>
        </div>
    </el-card>
    </el-col>
   </el-row>	
		</el-dialog>
		<!--新增业务刷卡总入口-->
		<el-dialog class="yewutankuang" :title='Title'  v-model="FrequencyCardBusiness" :close-on-click-modal="false" @close='closeDialog' style="width:100%;margin: 0 auto;padding-top: 0px;padding-right: 0.25em;padding-bottom: 2ex;padding-left: 0px;">            
			 <el-form :model="FrequencyCardBusinessForm" label-width="100px" :rules="FrequencyCardBusinessFormRules" ref="FrequencyCardBusinessForm"  >  
         <el-form-item label="卡号姓名" prop="CardNumber">
					<el-input  disabled v-model="FrequencyCardBusinessForm.CardNumber" auto-complete="off" style="width:49%"></el-input>
          	<el-input  disabled v-model="FrequencyCardBusinessForm.Name" auto-complete="off" style="width:49%"></el-input>
				</el-form-item>
				<!-- <el-form-item label="姓名" prop="Name">
					<el-input v-model="FrequencyCardBusinessForm.Name" auto-complete="off"></el-input>
				</el-form-item> -->
				<el-form-item label="性别" prop="Sex" >
          <el-input   v-model="FrequencyCardBusinessForm.Sex=='1'?'男':'女'" auto-complete="off"  ></el-input>
					<!-- <el-radio-group v-model="FrequencyCardBusinessForm.Sex">
						<el-radio class="radio" :label="1">男</el-radio>
						<el-radio class="radio" :label="0">女</el-radio>
					</el-radio-group> -->
				</el-form-item>
        <el-form-item label="是否赠送" prop="Gift" v-if="JSON.parse(this.getuserstate()).UserLevel==1">
					<el-radio-group v-model="FrequencyCardBusinessForm.Gift" >
						<el-radio class="radio" :label="0">是</el-radio>
						<el-radio class="radio" :label="1">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="是否赠送" prop="Gift" v-else>
					<el-radio-group v-model="FrequencyCardBusinessForm.Gift" >
						<!-- <el-radio class="radio" :label="0">是</el-radio> -->
						<el-radio class="radio" :label="1">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="年龄生日">
					<el-input-number v-model="FrequencyCardBusinessForm.Age" :min="0" :max="200" style="width:49%"></el-input-number>
								<el-date-picker type="date" placeholder="选择日期" v-model="FrequencyCardBusinessForm.Birthday" style="width:49%"></el-date-picker>
      	</el-form-item>
        <el-form-item label="电话" prop="Telephone">
					<el-input  v-model="FrequencyCardBusinessForm.Telephone" auto-complete="off"></el-input>
				</el-form-item>
				<!-- <el-form-item label="生日">
				</el-form-item> -->
				<el-form-item label="身份证号码" prop="IdNumber" >
					<el-input  disabled  v-model="FrequencyCardBusinessForm.IdNumber" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="课程教练" v-if="this.businessTitle=='TrainingCard'" prop="CoachId">
           <el-select style="width:49%" v-model="FrequencyCardBusinessForm.CoachId" clearable filterable  placeholder="请选择教练" >
                <el-option
                  v-for="item in coachOptions"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id">
               </el-option>
                 </el-select>
                 <!-- <el-select style="width:38%" v-model="FrequencyCardBusinessForm.CoachId" clearable filterable placeholder="选择或搜索教练">
                 <el-option
               v-for="item in coachOptions"
               :key="item.Id"
                  :label="item.Name"
               :value="item.Id">
                  </el-option>
                   </el-select> -->
                 <el-button style="width:49%" v-if="this.businessTitle=='TrainingCard'"  @click.native="selectInterval(FrequencyCardBusinessForm.Combo)">选择课程时间</el-button>
 				</el-form-item>        
				<el-form-item label="套餐列表" prop="Combo">  
          <el-select v-model="FrequencyCardBusinessForm.Combo" clearable filterable placeholder="请选择套餐" style="width:49%">
          <el-option
            v-for="item in options"
            :key="item.Id"
            :label="item.Name"
            :value="item.Id" @click.native="TrainingChange(item)">
          </el-option>
            </el-select>   
          <el-input v-if="this.businessTitle=='TrainingCard'" v-model="classhour" auto-complete="off" style="width:49%" placeholder="赠送课时"></el-input>  
          <el-input v-if="this.businessTitle=='FrequencyCard'" v-model="FrequencyCardBusinessForm.GiftTimes" auto-complete="off" style="width:49%" placeholder="赠送次数"></el-input>                        
        </el-form-item>
        <el-form-item label="套餐价格" prop="ComboMoney" v-if="this.businessTitle!='RechargeableCard'">
					<el-input  v-model="FrequencyCardBusinessForm.ComboMoney" disabled></el-input>
				</el-form-item>
        <el-form-item label="实收金额" prop="Amount" v-if="this.businessTitle!='RechargeableCard'">
					<el-input  v-model="FrequencyCardBusinessForm.Amount"></el-input>
				</el-form-item>
				<el-form-item label="备注">
					<el-input type="textarea" v-model="FrequencyCardBusinessForm.Remark"></el-input>
				</el-form-item>
					<el-form-item label="地址">
					<el-input type="textarea" v-model="FrequencyCardBusinessForm.Address"></el-input>
				</el-form-item>      		
        </el-form>
         <div slot="footer" class="dialog-footer">        
	      <el-button @click.native="FrequencyCardBusiness = false">取消</el-button>
				<el-button type="primary" @click.native="SubmitBusiness" :loading="addLoading">提交</el-button> 
        </div>
		  </el-dialog>
<el-dialog :title='TrainingClassName' width="100%" v-model="IntervalVisible" :close-on-click-modal="false">     
    <table id="" style="border: 1px solid #ddd;    width: 100%; margin-bottom: 20px;   max-width: 100%;  background-color: transparent;" cellspacing="0" cellpadding="0">
           
            <tbody>
                <tr class="active">
                    <th style="text-align: center; width: 14%;background-color: #f5f5f5;">
                        星期一
                    </th>
                    <th style="text-align: center; width: 14%;background-color: #f5f5f5;">
                        星期二
                    </th>
                    <th style="text-align: center; width: 14%;background-color: #f5f5f5;">
                        星期三
                    </th>
                    <th style="text-align: center; width: 14%;background-color: #f5f5f5;">
                        星期四
                    </th>
                    <th style="text-align: center; width: 14%;background-color: #f5f5f5;">
                        星期五
                    </th>
                    <th style="text-align: center; width: 14%; color:#999;" >
                        星期六
                    </th>
                    <th style="text-align: center; width: 14%;color:#999;">
                        星期日
                    </th>
                </tr>
                <tr>
                        <td style="padding: 1px;border: 1px solid #ddd;"    >
                            <div class="_cell"  style="min-height: 350px; overflow: hidden;text-align: center;"   ref="Monday">
                                <ol style="list-style-type: none; margin-top: 25px">
                                </ol>
								  <!-- <div slot="reference" class="name-wrapper" v-for="arr in td1" v-on:click.stop="selNum()">	 -->
                                <span slot="reference" class="name-wrapper"    v-for="arr in Monday" v-on:click.stop="selNum(arr,$event)" >                                 
                               <el-tag size="medium"  v-if="IfResult(arr)==false"  data-num="false" >{{arr.StartTime}}-{{arr.EndTime}}</el-tag>  
                              <el-tag size="medium"  v-else  data-num="false" style="background-color: rgb(32, 160, 255);" >{{arr.StartTime}}-{{arr.EndTime}}</el-tag>  
                             
							   	 <br>
							     <br>
                                </span>
								  <!-- </div> -->
                            </div>
                        </td>
                        <td style="padding: 1px;border: 1px solid #ddd;">
                            <div class="_cell"  style="min-height: 350px; overflow: hidden;text-align: center;" ref="Tuesday" data-num="false"   >
                                <ol style="list-style-type: none; margin-top: 25px">
                                </ol>
								  <!-- <div slot="reference" class="name-wrapper" v-for="arr in td1" v-on:click.stop="selNum()">	 -->
                                <span slot="reference" class="name-wrapper"    v-for="arr in Tuesday" v-on:click.stop="selNum(arr,$event)" >                                 
                               <el-tag size="medium"  v-if="IfResult(arr)==false"  data-num="false" >{{arr.StartTime}}-{{arr.EndTime}}</el-tag>  
                              <el-tag size="medium"  v-else  data-num="false" style="background-color: rgb(32, 160, 255);" >{{arr.StartTime}}-{{arr.EndTime}}</el-tag>  
							   	 <br>
							   <br>

                                </span>
								  <!-- </div> -->
                            </div>
                        </td>
                        <td style="padding: 1px;border: 1px solid #ddd;">
                            <div class="_cell"  style="min-height: 350px; overflow: hidden;text-align: center;" ref="Wednesday" data-num="false"   >
                                <ol style="list-style-type: none; margin-top: 25px">
                                </ol>
                                <span slot="reference" class="name-wrapper"    v-for="arr in Wednesday" v-on:click.stop="selNum(arr,$event)" >                                 
                               <el-tag size="medium"  v-if="IfResult(arr)==false"  data-num="false" >{{arr.StartTime}}-{{arr.EndTime}}</el-tag>  
                              <el-tag size="medium"  v-else  data-num="false" style="background-color: rgb(32, 160, 255);" >{{arr.StartTime}}-{{arr.EndTime}}</el-tag>  
							   	 <br>
							   <br>
                                </span>
                            </div>
                        </td>
                        <td style="padding: 1px;border: 1px solid #ddd;">
                            <div class="_cell"  style="min-height: 350px; overflow: hidden;text-align: center;" ref="Thursday" data-num="false"   >
                                <ol style="list-style-type: none; margin-top: 25px">
                                </ol>
                                <span slot="reference" class="name-wrapper"    v-for="arr in Thursday" v-on:click.stop="selNum(arr,$event)" >                                 
                               <el-tag size="medium"  v-if="IfResult(arr)==false"  data-num="false" >{{arr.StartTime}}-{{arr.EndTime}}</el-tag>  
                              <el-tag size="medium"  v-else  data-num="false" style="background-color: rgb(32, 160, 255);" >{{arr.StartTime}}-{{arr.EndTime}}</el-tag>  
							   	 <br>
							   <br>
                                </span>
                            </div>
                        </td>
                        <td style="padding: 1px;border: 1px solid #ddd;">
                            <div class="_cell"  style="min-height: 350px; overflow: hidden;text-align: center;" ref="Friday" data-num="false"   >
                                <ol style="list-style-type: none; margin-top: 25px">
                                </ol>
                                <span slot="reference" class="name-wrapper"    v-for="arr in Friday" v-on:click.stop="selNum(arr,$event)" >                                 
                               <el-tag size="medium"  v-if="IfResult(arr)==false"  data-num="false" >{{arr.StartTime}}-{{arr.EndTime}}</el-tag>  
                              <el-tag size="medium"  v-else  data-num="false" style="background-color: rgb(32, 160, 255);" >{{arr.StartTime}}-{{arr.EndTime}}</el-tag>  
							   	 <br>
							   <br>
                                </span>
                            </div>
                        </td>
                        <td style="padding: 1px;border: 1px solid #ddd;">
                            <div class="_cell"  style="min-height: 350px; overflow: hidden;text-align: center;" ref="Saturday" data-num="false"   >
                                <ol style="list-style-type: none; margin-top: 25px">
                                </ol>
                                <span slot="reference" class="name-wrapper"    v-for="arr in Saturday" v-on:click.stop="selNum(arr,$event)" >                                 
                               <el-tag size="medium"  v-if="IfResult(arr)==false"  data-num="false" >{{arr.StartTime}}-{{arr.EndTime}}</el-tag>  
                              <el-tag size="medium"  v-else  data-num="false" style="background-color: rgb(32, 160, 255);" >{{arr.StartTime}}-{{arr.EndTime}}</el-tag>  
							   	 <br>
							   <br>
                                </span>

                            </div>
                        </td>
                        <td style="padding: 1px;border: 1px solid #ddd;">
                            <div class="_cell"  style="min-height: 350px; overflow: hidden;text-align: center;" ref="Sunday" data-num="false"  >
                                <ol style="list-style-type: none; margin-top: 25px">
                                </ol>
                                <span slot="reference" class="name-wrapper"    v-for="arr in Sunday" v-on:click.stop="selNum(arr,$event)" >                                 
                               <el-tag size="medium"  v-if="IfResult(arr)==false"  data-num="false" >{{arr.StartTime}}-{{arr.EndTime}}</el-tag>  
                              <el-tag size="medium"  v-else  data-num="false" style="background-color: rgb(32, 160, 255);" >{{arr.StartTime}}-{{arr.EndTime}}</el-tag>  
							   	 <br>
							   <br>
                                </span>
                            </div>
                        </td>
                </tr>
            </tbody>
        </table>
		<!-- <div slot="footer" class="dialog-footer">
				<el-button  @click.native="addFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
		</div> -->
	  </el-dialog>
</section>
</template>
<script>
	import util from '../../common/js/util'
import {mapGetters} from 'vuex';
import {getCoachOptionsList,getIntervalList,MonthCardBusiness,YearCardBusiness,TrainingCardBusiness,OwnerBusiness,RechargeableCardBusiness,FrequencyCardBusiness,editMember,GetMemberInfoByIcCard,getFrequencyCardOptionsList,getMonthCardOptionsList,getYearCardOptionsList,getRechargeableCardOptionsList,getTrainingCardOptionsList} from  '../../api/api';
// import url from "../../assets/images/hamburger.png"

import RechargeableCardXC from "../../assets/images/RechargeableCardXC.jpg"

import FrequencyCard from "../../assets/images/FrequencyCard.jpg"
import MonthCard from "../../assets/images/MonthCard.jpg"
import RechargeableCard from "../../assets/images/RechargeableCard.jpg"
import TrainingCard from "../../assets/images/TrainingCard.jpg"
import YearCard from "../../assets/images/YearCard.jpg"
import IdCard from "../../assets/images/IcCard.png"
import Vue from 'vue';


export default {
    data() {
    return {
     
      //选择课程 相关数据源与模型
      //  赠送课时
      classhour:'', 
      TrainingChangeVisible:false,//培训班是否变更
      SubmitStrcut:[],//提交选中的时段
      IntervalVisible:false,
      TrainingClassName:'',
      SeleteComboId:'',
			  //星期 模型
			  Monday:[],
			  Tuesday:[],
			  Wednesday:[],
			  Thursday:[],
			  Friday:[],
			  Saturday:[],
			  Sunday:[],
        
        //选中后的模型
        
        SelectMonday:[],
			  SelectTuesday:[],
			  SelectWednesday:[],
			  SelectThursday:[],
			  SelectFriday:[],
			  SelectSaturday:[],
			  SelectSunday:[],
     //次卡 月卡 年卡 列表 教练
       options:[],
       coachOptions:[],
       Title:'',
    //   imageurl:url,
    RechargeableCardXC:RechargeableCardXC,
      FrequencyCard:FrequencyCard,
       MonthCard:MonthCard,
       RechargeableCard:RechargeableCard,
       TrainingCard:TrainingCard,
       YearCard:YearCard,
       IdCard:IdCard,
       show2: false,
       //input 给身份证读卡器输入框光标焦点
        focusvalue:false,
        inputIdCard: '',
      Machine: false,//读卡器界面是否显示
      //业务类别标识
      businessTitle:'',
      addLoading: false,
    	machineForm: {
        },
        //会员基础信息预备model
        MemberInfo:{        
        },
         //基础设置列表
        //业务模型 属性块
        FrequencyCardBusiness:false,
        FrequencyCardBusinessForm:{
          Id:0,
         CardNumber:'',
         Name:'',
         Sex:-1,
         Age:0,
         Telephone:'',
         Birthday:'',
         IdNumber:'',
         TenancyId:'',
         Address:'',
         CardType:'',
         State:'',
         Combo:'',
         Gift:1,
         Remark:'',
         CoachId:0,
         GiftTimes:0

        },
        FrequencyCardBusinessFormRules:{
          // Combo:[{
          //    required: true, message: '请选择套餐', trigger: 'change' 
          // }],
          CoachId:[],
          
        	CardType: [
						{ type:'number', required: true, message: '请选择卡类别'}
					],
        },       
        //业务已办理提醒模板与属性
          MessageTitle:'',
          ComboName:'',
    };
  },
  methods:{
     closeDialog(){
		this.inputIdCard="";
      this.onCellClick(event);
    },
   onCellClick(event)
   {
      // console.log(45555);
      this.$nextTick(function(){
         this.$refs['siteInput'].focus();
          // this.$(event.target).children().find("input").focus();
      })
   },
   IfResult(arr)
    {
      let result=false;
      switch(arr.WeekName)
				   {					
				   case 'Monday': 
				   {
            let List=this.SelectMonday.filter(i => {
		              return  i.Id == arr.Id});
            if(List.length>0)
            {
              result= true;
            }
            else
            {
              result=false;
            }        
					break;
				   }
				   	case 'Tuesday': 
				   {
            let List=this.SelectTuesday.filter(i => {
		              return  i.Id == arr.Id});
            if(List.length>0)
            {
              result= true;
            }
            else
            {
              result=false;
            }
					break;
					}
				   	case 'Wednesday': 
				   {
            let List=this.SelectWednesday.filter(i => {
		              return  i.Id == arr.Id});
            if(List.length>0)
            {
              result= true;
            }
            else
            {
              result=false;
            }
					break;
				   }
				   	case 'Thursday': 
				   {
            let List=this.SelectThursday.filter(i => {
		              return  i.Id == arr.Id});
            if(List.length>0)
            {
              result= true;
            }
            else
            {
              result=false;
            }
                     break;
				   }
				   	case 'Friday': 
				   {
            let List=this.SelectFriday.filter(i => {
		              return  i.Id == arr.Id});
            if(List.length>0)
            {
              result= true;
            }
            else
            {
              result=false;
            }
					break;
				   }
				   case 'Saturday': 
				   {
            let List=this.SelectSaturday.filter(i => {
		              return  i.Id == arr.Id});
            if(List.length>0)
            {
              result= true;
            }
            else
            {
              result=false;
            }
					break;
				   }
				   case 'Sunday': 
				   {
            let List=this.SelectSunday.filter(i => {
		              return  i.Id == arr.Id});
            if(List.length>0)
            {
              result= true;
            }
            else
            {
              result=false;
            }
					break;
				   }				   				   
				   default:
				     break;
				}
      // console.log('样式'+result);
      return result;   
    },   
    TrainingChange(e){//选择套餐列表
      console.log("选择套餐列表",e);
      this.FrequencyCardBusinessForm.ComboMoney=e.Money;
      this.FrequencyCardBusinessForm.Amount=e.Money;
      this.TrainingChangeVisible=true;
    },
    delete(value){
        value = value.filter(i => {
		    return i.WeekName != value});
	     	},
  	selNum(Row,e){
 			  if(e.target.getAttribute('data-num')=='false'||e.target.getAttribute('data-num')==null)
			  {
				 e.target.style.backgroundColor ="#20a0ff";
				 e.target.setAttribute('data-num','true');
				//新增时间段
			    switch(Row.WeekName)
				   {
					//在结构体中新增 项目
				   case 'Monday': 
				   {
          this.SelectMonday.push(Row);
          // console.log('选中');
					break;
				   }
				   	case 'Tuesday': 
				   {
					this.SelectTuesday.push(Row);
					break;
					}
				   	case 'Wednesday': 
				   {
					this.SelectWednesday.push(Row);
					break;
				   }
				   	case 'Thursday': 
				   {
					this.SelectThursday.push(Row);
                     break;
				   }
				   	case 'Friday': 
				   {
					this.SelectFriday.push(Row);
					break;
				   }
				   case 'Saturday': 
				   {
					this.SelectSaturday.push(Row);
					break;
				   }
				   case 'Sunday': 
				   {
					this.SelectSunday.push(Row);
					break;
				   }				   				   
				   default:
				     break;
				}
				//灰 #8391a5 白#FFFFFF
			  }
			  else
			  {
				  //取消选中 同时从结构体中删除 结构项
			   e.target.style.backgroundColor = "#8391a5";
			    e.target.setAttribute('data-num','false');
       switch(Row.WeekName)
				{
				   case 'Monday': 
				   {
             
                   this.SelectMonday=this.SelectMonday.filter(i => {
                  return  i.Id != Row.Id});
                  // console.log('取消选中'+this.SelectMonday);
					break;
				   }
				   	case 'Tuesday': 
				   {
                   this.SelectTuesdayy=this.SelectTuesday.filter(i => {
                  return  i.Id != Row.Id});
					break;
					}
				   	case 'Wednesday': 
				   {
                   this.SelectWednesday=this.SelectWednesday.filter(i => {
                  return  i.Id != Row.Id});
					break;
				   }
				   	case 'Thursday': 
				   {
                   this.SelectThursday=this.SelectThursday.filter(i => {
                  return  i.Id != Row.Id});
                     break;
				   }
				   	case 'Friday': 
				   {
                   this.SelectFriday=this.SelectFriday.filter(i => {
                  return  i.Id != Row.Id});
					break;
				   }
				   case 'Saturday': 
				   {
                   this.SelectSaturday=this.SelectSaturday.filter(i => {
                  return  i.Id != Row.Id});
					break;
				   }
				   case 'Sunday': 
				   {
                   this.SelectSunday=this.SelectSunday.filter(i => {
                  return  i.Id != Row.Id});
					break;
				   }				   				   
				   default:
				     break;
				}
			  }   
    },
        addWeek(data){
         switch (data.WeekName) {
				  case 'Monday': 
				   {
					this.Monday.push(data);
					break;
				   }
				   	case 'Tuesday': 
				   {
					this.Tuesday.push(data);
					break;
					}
				   	case 'Wednesday': 
				   {
					this.Wednesday.push(data);
					break;
				   }
				   	case 'Thursday': 
				   {
					this.Thursday.push(data);
           break;
				   }
				   	case 'Friday': 
				   {
					this.Friday.push(data);
					break;
				   }
				   case 'Saturday': 
				   {
					this.Saturday.push(data);
					break;
				   }
				   case 'Sunday': 
				   {
					this.Sunday.push(data);
					break;
				   }				   				   
				   default:
				     break;
			     }  
	       	},
        //选择时间段
         selectInterval(Combo){
              if(Combo==null)
              {
                  this.$message({
				            	message: '请选择套餐',
					          	type: 'error'
					        	});
              }
              else
              {
                if(this.TrainingChangeVisible==true)
                {
                  //初始化被选中模型的数据为空 初始化培训班选中条件为false 
                 this.Monday=[],
			            this.Tuesday=[],
			            this.Wednesday=[],
			            this.Thursday=[],
			            this.Friday=[],
			            this.Saturday=[],
			            this.Sunday=[],  
                 this.SelectMonday=[],
			            this.SelectTuesday=[],
			            this.SelectWednesday=[],
			            this.SelectThursday=[],
			            this.SelectFriday=[],
			            this.SelectSaturday=[],
			            this.SelectSunday=[],                 
                  this.TrainingChangeVisible=false;
                this.IntervalVisible=true;
                let para={
                     TrainingComboId:Combo
                };
                getIntervalList(para).then((res)=>{
                  // console.log(res);
                	let	{status,data}=res;
                  data.forEach(item => {
						    	 this.addWeek(item); 
					     	  });
                }).catch(error=>{
                 alert('网络错误');
                });		
                }
                else
                {
                  //如果培训班为改变
                this.IntervalVisible=true;
                }
              }
           },
     //通知消息 业务已办理的弹出通知
        open9(ResModel) {
          //创建虚拟节点 
         
           const h = this.$createElement;
           let CardType=ResModel.CardType;
              //虚拟dom模型
              let Model=h('p', null, [
                        h('table', null, ''),                       
                        h('td',null,'套餐名称:'),
                        h('td',null,'无'),
                        h('tr',null,''),
                        h('td',null,'剩余次数'),
                        h('td',null,'无'),
                    ]);
            switch(CardType)
            {
              case '0':
              {
                Model=h('p', null, [
                        h('table', null, ''),                       
                        h('td',null,'套餐名称:'),
                        h('td',null,ResModel.ComboName),
                        h('tr',null,''),
                        h('td',null,'剩余次数:'),
                        h('td',null,ResModel.SurplusTimes),
                         h('tr',null,''),                       
                        h('td',null,'有效期限:'),
                        h('td',null,ResModel.FinalDate),
                         ]);
                break;
              }
              case '1':
              {
                Model=h('p',null,[
                  h('table',null,''),
                  h('td',null,'套餐名称:'),
                  h('td',null,ResModel.ComboName),
                  h('tr',null,''),
                  h('td',null,'消费期限:'),
                  h('td',null,ResModel.TimeInterval),                  
                ]);
                break;
              } 
              case '2':
              {
                Model=h('p',null,[
                  h('table',null,''),
                  h('td',null,'套餐名称:'),
                  h('td',null,ResModel.ComboName),
                  h('tr',null,''),
                  h('td',null,'消费期限:'),
                  h('td',null,ResModel.TimeInterval),                  
                ]);
                break;
              }
               case '3':
              {
                 Model=h('p',null,[
                  h('table',null,''),
                  h('td',null,'套餐名称:'),
                  h('td',null,ResModel.ComboName),
                  h('tr',null,''),
                  h('td',null,'卡余额:'),
                  h('td',null,ResModel.Balance),                  
                ]);              
                break;
              } 
              case '4':
              {
                Model=h('p',null,[
                  h('table',null,''),
                  h('td',null,'套餐名称:'),
                  h('td',null,ResModel.ComboName),
                  h('tr',null,''),
                  h('td',null,'培训时间:'),
                  h('td',null,ResModel.TrainingTimeInterval),   
                  h('tr',null,''),
                  h('td',null,'培训教练:'),
                  h('td',null,ResModel.CoachName),                
                ]);
                break;
              }
               case '5':
              {
                 Model=h('p',null,[
                  h('table',null,''),
                  h('td',null,'套餐名称:'),
                  h('td',null,ResModel.ComboName),
                  h('tr',null,''),
                  h('td',null,'卡余额:'),
                  h('td',null,ResModel.Balance),                  
                ]);           
                break;
              }
              default:
              break
            }
            this.$notify({
            title: this.MessageTitle,
            type: 'info',
            //  dangerouslyUseHTMLString: true,
             message: Model ,
             duration:6000
            //  position: 'bottom-left'
                  });
              },   
      Radiochange(value){
             var user=JSON.parse(this.getuserstate());
             if(value==0)
             {
               if(user.UserLevel!=1)
               {
                   this.$message({
				            	message: '您的账号没有赠送权限',
					          	type: 'error'
					        	});
               }
             }
          // console.log(value);
      },
    			//基础设置 次卡年卡月卡 列表
			getCombo(){
				let para={
        }
        if(this.businessTitle=='FrequencyCard')
        {
          getFrequencyCardOptionsList(para).then((res)=>{
					//  console.log(res);
          this.options=res.data;
				 }).catch(error=>{
				 })
        }
         if(this.businessTitle=='MonthCard')    
         {//月卡          
          getMonthCardOptionsList(para).then((res)=>{
					//  console.log(res);
          this.options=res.data;
				 }).catch(error=>{
				 })
         }
        if(this.businessTitle=='RechargeableCard'||this.businessTitle=='Rechargeable')
        {//充值卡
          getRechargeableCardOptionsList(para).then((res)=>{
					//  console.log(res);
          this.options=res.data;
				 }).catch(error=>{
				 })
        }
        if(this.businessTitle=='TrainingCard')
        {//培训卡
         getTrainingCardOptionsList(para).then((res)=>{
					//  console.log(res);
          this.options=res.data;
				 }).catch(error=>{
         })
         getCoachOptionsList(para).then((res)=>{
					//  console.log(res);
          this.coachOptions=res.data;
				 }).catch(error=>{
         })         
        }
        if(this.businessTitle=='YearCard')
        {//年卡
         getYearCardOptionsList(para).then((res)=>{
					//  console.log(res);
          this.options=res.data;
				 }).catch(error=>{
				 })
        }
			},
    formatSex: function (row, column) {
				return row.sex == 1 ? '男' : row.sex == 0 ? '女' : '未知';
			},
    ...mapGetters(['getuserstate']),
             MachineClose(){
              this.Machine=false;                           
             },
          //业务窗口界面
           BusinessHandle(){
                if(this.inputIdCard=='')
                {
                    this.$message({
				              				message: '请刷卡或输入卡号',
					            				type: 'error'
					        	});
                }
                else
                {
                  let para={
                    IcCard:this.inputIdCard,
                    TenancyId:JSON.parse(this.getuserstate()).TenancyId,
                    // CardType:this.businessTitle=='FrequencyCard'?0:this.businessTitle=='MonthCard'?1:this.businessTitle=='YearCard'?2:this.businessTitle=='RechargeableCard'?3:this.businessTitle=='TrainingCard'?4:''
                     }
                   if(this.businessTitle=='FrequencyCard'||this.businessTitle=='MonthCard'||this.businessTitle=='YearCard'||this.businessTitle=='RechargeableCard'||this.businessTitle=='TrainingCard')
                      {//次卡 年卡 月卡
                    GetMemberInfoByIcCard(para).then((res)=>{
                       console.log(res);
                       let { code,msg,data } = res.data;                     
                      //  console.log(code+' '+msg+' '+data);
                       if(code!=200)
                       {
                         
                          this.$message({
				              				message: msg,
					            				type: 'error'
                            });
                         
                          this.inputIdCard=''  
                       }
                       else
                       {
                             this.FrequencyCardBusinessForm=data;
                             this.Title=this.businessTitle=='FrequencyCard'?'次卡':this.businessTitle=='MonthCard'?'月卡':this.businessTitle=='YearCard'?'年卡':this.businessTitle=='TrainingCard'?'培训卡':this.businessTitle=='RechargeableCard'?'充值卡':this.businessTitle=='Rechargeable'?'充值卡续充':'';
                             this.FrequencyCardBusinessForm.CardType=this.businessTitle=='FrequencyCard'?0:this.businessTitle=='MonthCard'?1:this.businessTitle=='YearCard'?2:this.businessTitle=='RechargeableCard'?3:this.businessTitle=='TrainingCard'?4:'';
                             //默认不赠送
                             this.FrequencyCardBusinessForm.Gift=1
                             this.FrequencyCardBusiness=true;
                       }
                        //获取基础设置列表
                      this.getCombo();
                    }).catch(error=>{
                      error=>{alert('系统错误');}
                    }) 
                    }
                  if(this.businessTitle=='Rechargeable')
                    {//充值卡续充
                      let ownerPara={
                        cardNumber:this.inputIdCard,
                      }
                      OwnerBusiness(ownerPara).then((res)=>{
                         let { Success,Msg } = res.data;
                         console.log(Success);
                      if(!Success)
                       {
                          this.$message({
				              				message: Msg,
					            				type: 'error'
					            			});
                       }
                       else
                       {

                           this.$message({
				              				message: Msg,
					            				type: 'success'
					            			});                           
                       }                         
                          this.getCombo();                        
                       }).catch(error=>{
                         error=>{alert('系统错误');}
                       }) 
                    }
                }                       
           },
       SubmitBusiness: function () {
				this.$refs.FrequencyCardBusinessForm.validate((valid) => {
				 if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.addLoading = true;
							//NProgress.start();
              let para= Object.assign({}, this.FrequencyCardBusinessForm,{'ConsumptionTime':Date.now()});							
              para.Birthday = (!para.Birthday || para.Birthday == '') ? '' : util.formatDate.format(new Date(para.Birthday), 'yyyy-MM-dd');
              para.ConsumptionTime= (!para.ConsumptionTime || para.ConsumptionTime == '') ? '' : util.formatDate.format(new Date(para.ConsumptionTime), 'yyyy-MM-dd hh:mm:dd');
              //  console.log(para);
              // para.push('ConsumptionTime',Date.now());
             if(this.businessTitle=='FrequencyCard')
              {
                FrequencyCardBusiness(para).then((res)=>{
              	this.addLoading = false;
								//NProgress.done();
								let { Success,Msg } = res.data;
								if(Success)
								{
                  this.$message({
									message: Msg,
									type: 'success'
								});
								}else
								{
                  this.$message({
									message: Msg,
									type: 'error'
								});
								}
								this.$refs['FrequencyCardBusinessForm'].resetFields();
                this.FrequencyCardBusiness = false;
                this.inputIdCard='';
                this.focusvalue=true;
                this.onCellClick(event);
                }).catch(error=>{alert('系统错误');});
              }

             if(this.businessTitle=='MonthCard')
              {
              	MonthCardBusiness(para).then((res) => {
							
								this.addLoading = false;
								//NProgress.done();
								let { Success,Msg } = res.data;
								if(Success)
								{
                  this.$message({
									message: Msg,
									type: 'success'
								});
								}else
								{
                  this.$message({
									message: Msg,
									type: 'error'
								});
								}
								this.$refs['FrequencyCardBusinessForm'].resetFields();
                this.FrequencyCardBusiness = false;
                this.inputIdCard='';
                this.focusvalue=true;
                this.onCellClick(event);
								// _this.$router.push('/Business');
							}) .catch(error=>{
                alert('系统错误');
               });
               }
          
              if(this.businessTitle=='YearCard')
             {
              	YearCardBusiness(para).then((res) => {
							
								this.addLoading = false;
								//NProgress.done();
								let { Success,Msg } = res.data;
								if(Success)
								{
                  this.$message({
									message: Msg,
									type: 'success'
								});
								}else
								{
                  this.$message({
									message: Msg,
									type: 'error'
								});
								}
								this.$refs['FrequencyCardBusinessForm'].resetFields();
                this.FrequencyCardBusiness = false;
                this.inputIdCard='';
                this.focusvalue=true;
                this.onCellClick(event); 
								// _this.$router.push('/Business');
							}) .catch(error=>{
                alert('系统错误');
               });
             }           

            if(this.businessTitle=='RechargeableCard'||this.businessTitle=='Rechargeable')	
             {                  
              	RechargeableCardBusiness(para).then((res) => {							
								this.addLoading = false;
								//NProgress.done();
								let { Success,Msg } = res.data;
								if(Success)
								{
                  this.$message({
									message: Msg,
									type: 'success'
							  	});
								}else
								{
                  this.$message({
									message: Msg,
									type: 'error'
							  	});
								}
								this.$refs['FrequencyCardBusinessForm'].resetFields();
                this.FrequencyCardBusiness = false;
                this.inputIdCard='';
                this.focusvalue=true;
                 this.onCellClick(event);
								// _this.$router.push('/Business');
						   	}) .catch(error=>{
                alert('系统错误');
               });   
             }
             if(this.businessTitle=='TrainingCard')
             {
            
               this.SubmitStrcutInit();
               if(this.SubmitStrcut.length<1)
               {
                 this.addLoading = false;
                 this.$message({
									message: '未选择课程时间',
									type: 'error'
							  	});
               }
               else
               {
             //  console.log(this.SelectMonday);
               if( this.FrequencyCardBusinessForm.CoachId==0||this.FrequencyCardBusinessForm.CoachId==null)
              {
                this.addLoading = false;
                this.$message({
									message: '请选择教练',
									type: 'error'
                  });
                   
                  return;
              }
              else
              {
                let hour=this.classhour==''?0:this.classhour;
 let NewPara=Object.assign({}, this.FrequencyCardBusinessForm,{'ConsumptionTime':Date.now()},{'SubmitStrcut':JSON.stringify(this.SubmitStrcut)},{'classhour':hour});
                  NewPara.Birthday = (!NewPara.Birthday || NewPara.Birthday == '') ? '' : util.formatDate.format(new Date(NewPara.Birthday), 'yyyy-MM-dd');
                  NewPara.ConsumptionTime= (!NewPara.ConsumptionTime || NewPara.ConsumptionTime == '') ? '' : util.formatDate.format(new Date(NewPara.ConsumptionTime), 'yyyy-MM-dd hh:mm:dd');
              	TrainingCardBusiness(NewPara).then((res) => {							
								this.addLoading = false;
								//NProgress.done();
								let { Success,Msg } = res.data;
								if(Success)
								{
                  this.$message({
									message: Msg,
									type: 'success'
							  	});
								}else
								{
                  this.$message({
									message: Msg,
									type: 'error'
							  	});
								}
								this.$refs['FrequencyCardBusinessForm'].resetFields();
                this.FrequencyCardBusiness = false;
                this.inputIdCard='';
                this.focusvalue=true;
                this.SubmitStrcut=[];
                 this.onCellClick(event);
								// _this.$router.push('/Business');
						   	}) .catch(error=>{
                alert('系统错误');
               });   
              }
                 
               }
             }
            });           
					}
        });
 
      },
      SubmitStrcutInit(){
        this.SubmitStrcut=[];
		   if(this.SelectMonday.length>0)
		   {
		     this.Week={
				WeekName:'Monday',
				WeekList:this.SelectMonday
			 }
			 this.SubmitStrcut.push(this.Week);
		   }
		  if(this.SelectTuesday.length>0)
		   {

		     this.Week={
				WeekName:'Tuesday',
				WeekList:this.SelectTuesday
			 }
			 this.SubmitStrcut.push(this.Week);
		   }
		   if(this.SelectWednesday.length>0)
		   {

		     this.Week={
				WeekName:'Wednesday',
				WeekList:this.SelectWednesday
			 }
			 this.SubmitStrcut.push(this.Week);
		   }
		   if(this.SelectThursday.length>0)
		   {
		     this.Week={
				WeekName:'Thursday',
				WeekList:this.SelectThursday
			 }
			 this.SubmitStrcut.push(this.Week);
		   }
		   if(this.SelectFriday.length>0)
		   {
		    this.Week={
				WeekName:'Friday',
				WeekList:this.SelectFriday
			 }
			 this.SubmitStrcut.push(this.Week);
		   }
		   if(this.SelectSaturday.length>0)
		   {
		     this.Week={
				WeekName:'Saturday',
				WeekList:this.SelectSaturday
			 }
			 this.SubmitStrcut.push(this.Week);
		   }
		   if(this.SelectSunday.length>0)
		   {

		    this.Week={
				WeekName:'Sunday',
				WeekList:this.SelectSunday
			 }
			 this.SubmitStrcut.push(this.Week);
		   }

		},
           //读卡器界面
        machineInit(flag){
            this.focusvalue=false;
            this.businessTitle=flag;
            this.inputIdCard='';
             
            this.MachineHandle();
        },
      	MachineHandle: function () {
          this.Machine = true;
          this.focusvalue=true;
          this.onCellClick(event);
			},
      changeActive($event){
             $event.currentTarget.className="Activebg";
      },
      removeActive($event){
             $event.currentTarget.className="removeActivebg";
      }
  }
  
  ,
  mounted() {
      this.show2=true;
                   var user=JSON.parse(this.getuserstate());
      //  let inputelement=document.getElementById('user');
      //    inputelement.focus();
    },
    
}

</script>
<style scoped>
/* .active { background-color: red; } */
#el-title .el-dialog__title {color: red!important;}
/* .time {
    font-size: 13px;
    color: #999;
  } */
  .el-form-item {
    margin-bottom: 22px;
    height: 18px;
    }
  .Activebg {
    background-color:greenyellow /*此处更换为所需的颜色代码*/
    }
  .removeActivebg{
     background-color:white 
    }
  .transition-box {
    margin-bottom: 10px;
    width: 200px;
    height: 100px;
    border-radius: 4px;
    background-color: #409EFF;
    text-align: center;
    color: #fff;
    padding: 40px 20px;
    box-sizing: border-box;
    margin-right: 20px;
  }
  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  /* .button {
    padding: 0;
    float: right;
  } */

  .image {
    width: 100%;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }
  
  .clearfix:after {
      clear: both
  }
  .input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
</style>




// WEBPACK FOOTER //
// Business.vue?ee5b2af6